import {
  Author,
  BookOfAuthor,
  GetDetailResponse,
  GetListResponse,
} from "@app/types";
import HttpService from "@core/services/http/http.service";
import { RequestParams, Signal } from "@core/services/http/http.type";

class _AuthorService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<Author>>(
      "/user/api/v2/author/search",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public getDetail(authorId: number, signal?: Signal) {
    return HttpService.get<GetDetailResponse<Author>>(
      `/user/api/v2/author/info?authorId=${authorId}`,
      {
        signal,
      }
    );
  }

  public getBooksOfAuthor(
    authorId: number,
    requestParams?: RequestParams,
    signal?: Signal
  ) {
    return HttpService.get<GetListResponse<BookOfAuthor>>(
      "/user/api/v2/author/books",
      {
        queryParams: { ...requestParams, authorId },
        signal,
      }
    );
  }

  public followAuthor(authorId: number) {
    return HttpService.post(
      `/user/api/v2/user-author-relartion?authorId=${authorId}`
    );
  }
}

const AuthorService = new _AuthorService();

export default AuthorService;
